import { apiService } from './api.service';
import { DEFAULT_AURORA_PLATFORM } from '../constants';

export interface AuroraDesignResponse {
  design_id: string;
  design_summary: Record<string, any>;
  roof_design_summary: Record<string, any>;
}

class AuroraService {
  async getDesignById(designId: string, platform: string = DEFAULT_AURORA_PLATFORM): Promise<AuroraDesignResponse> {
    return apiService.get<AuroraDesignResponse>(`/aurora/designs/${designId}`, { platform });
  }
}

export const auroraService = new AuroraService();
